<template>

  <ion-page id="legacy-rep-manger-component-page">

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
              @alert-result="alertResult"></AlertReplacement>

    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
             :style="styleOneFrame" :key="menuTrigger">

        <div v-show="showTour">
          <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
        </div>

        <div id="repmanager-container">
          <div :class="{ 'text-light' : isDark,'text-dark' : !isDark, 'repmanager-center-text' : true ,
                      'repmanager-heading-color' : true }" >
            {{ descriptionHeading }}
          </div>
    
          <div class="form-check">
            <input v-show="showCheckbox" class="form-check-input" type="checkbox" value="" v-model="allSelected"
                @change="onAllCheckboxClick()">
            <ion-button  @click="switchButtonClick()">{{ buttonText }}</ion-button>
          </div>
 
          <div :class="{ 'text-light' : isDark,'text-dark' : !isDark , 'repmanager-heading-color' : true }">
            {{ whiteHeading}}
          </div>
          <div v-for="item in whiteRepertoires" v-bind:key="item.id">
            <div class="form-check">
              <input v-show="showCheckbox" class="form-check-input" type="checkbox" value="" 
                      id=item.name @change="onCheckboxClick($event,'white',item.index)"
                      v-model="whiteRepertoires[item.index].selected">

              <input v-if="!showCheckbox" class="form-check-input" type="radio" :value="item.radio"
                      @change="onRadioClick($event,'white',item.index)"
                      v-model="selectedId">

              <label class="form-check-label" for=item.name>
                {{ item.name }}
              </label>
            </div>
          </div>
 
          <div :class="{ 'text-light' : isDark,'text-dark' : !isDark , 'repmanager-heading-color' : true}">
            {{ blackHeading}}
          </div>

          <div v-for="item in blackRepertoires" v-bind:key="item.id">
            <div class="form-check">
              <input  v-show="showCheckbox" class="form-check-input" type="checkbox" value="" 
                      @change="onCheckboxClick($event,'black',item.index)"
                      id=item.name v-model="blackRepertoires[item.index].selected">

              <input v-if="!showCheckbox" class="form-check-input" type="radio" :value="item.radio"
                      @change="onRadioClick($event,'black',item.index)"
                      v-model="selectedId">

              <label class="form-check-label" for=item.name>
                {{ item.name }}
              </label>
            </div>
          </div>

          <div :class="{ 'text-light' : isDark,'text-dark' : !isDark ,
                        'repmanager-heading-color' : true}">
            {{ unknownHeading}}
          </div>
          <div v-for="item in unknownRepertoires" v-bind:key="item.id">
            <div class="form-check">
              <input  v-show="showCheckbox" class="form-check-input" type="checkbox" value="" 
                      @change="onCheckboxClick($event,'unknown',item.index)"
                      id=item.name v-model="unknownRepertoires[item.index].selected">

              <input v-if="!showCheckbox" class="form-check-input" type="radio" :value="item.radio"
                      @change="onRadioClick($event,'unknown',item.index)"
                      v-model="selectedId">

              <label class="form-check-label" for=item.name>
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
    <Toolbar id="the_toolbar" :ignoreClicks="showTour" 
                  :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';

  import AlertReplacement from '@/components/AlertReplacement.vue'

  import Toolbar from '@/components//Toolbar.vue'
  import ModalLegacyAddRepertoire from '@/components/ModalLegacyAddRepertoire.vue'
  import ModalLegacyCopyRepertoire from '@/components/ModalLegacyCopyRepertoire.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import { t } from '@/composables/translateText.js'

  import { useGetData , useGetDataDownload } from '@/composables/getData.js'
  import { availableWidthHeight } from '@/composables/screenSize'
  import Tour from '@/components/Tour.vue'
  import { useStringStore } from '@/stores/stringStore';
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
              from '@/composables/toolbarSupport.js'

  import { ref, watch } from 'vue'

  const menuTrigger = ref(0)
  
  const stringStore = useStringStore()
  const connectionStore = useConnectionStore()

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

  
  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")

  const hasChanges = ref(false)
  const toolbarTrigger = ref(0)

  const newRepertoireName = ref("")
  const picked = ref("")

  const tourTrigger = ref(0)
  const showTour = ref(false)

  const alertInfo = ref({})
  const alertTrigger = ref(0)

  const props = defineProps({
    descriptionHeading : {
      type : String,
      default : ""
    },
    whoCalled : {
      type : String,
      default : "practice"
    },
    downloadID : {
      type : String,
      default : "0"
    }
  })

  //console.log("******** repmanager  ",props.whoCalled,props.downloadID)

  const emit = defineEmits(['repertoire-manager-done'])

  const TOOLBAR_ADD = 0
  const TOOLBAR_COPY = 1
  const TOOLBAR_RENAME = 2
  const TOOLBAR_COLOR = 3
  const TOOLBAR_DELETE = 4

  const TOOLBAR_DONE_FOR_IMPORT = 7
  const TOOLBAR_DONE = 8

  const TOOLBAR_DOWNLOAD = 9

  const toolbarElements = ref([
    { index : TOOLBAR_ADD, label : t("Add") ,disabled : false,collapse:false},
    { index : TOOLBAR_COPY, label : t("Copy") , disabled : true,collapse:false},
    { index : TOOLBAR_RENAME, label : t("Rename") , disabled : true,collapse:true},
    { index : TOOLBAR_COLOR, label : t("Set-Color") , disabled : false,collapse:false},
    { index : TOOLBAR_DELETE, label : t("Delete") , disabled : true,collapse:false},
  ])

  if (props.whoCalled == "import") {
    const item = { index : TOOLBAR_DONE_FOR_IMPORT, label : t("Import") ,disabled : false}
    toolbarElements.value.push(item)
    //toolbarElements.value.splice(0, 0, item)
  }

  const toolbarDownloadElements = [
    { index : TOOLBAR_DOWNLOAD, label : t("Download") ,disabled : false,collapse:false},
  ]
 
  if (props.whoCalled == "export")
    toolbarElements.value = toolbarDownloadElements

  var changesMade = false
  var initialValues = []
  const resultsData = ref([])

  const allSelected = ref(false)
  const showCheckbox = ref(false)
  const entryToCopy = ref({})
  const entryToRename = ref({})
  const entryToShowTree = ref({})
  const copyInfo = ref("")
  const selectedEntries = ref([])
  const repertoireString = ref("")

  const BUTTON_SWITCH_MULTIPLE = t("Switch to Multiple Selector")
  const BUTTON_SWITCH_SINGLE = t("Switch to Single Selector")
  const buttonText = ref((showCheckbox.value) ? BUTTON_SWITCH_SINGLE : BUTTON_SWITCH_MULTIPLE)

  const addName = ""
  const addColor = "white"
  const selectedId = ref("")
  const whiteRepertoires = ref([])
  const blackRepertoires = ref([])
  const unknownRepertoires = ref([])
  const showPracticeHeading = ref(props.whoCalled == "practice")

  //console.log("who called",props.whoCalled,showPracticeHeading.value)
  const practiceSwitchLabel = ref("White Repertoires")
  const whiteHeading = ref(t("White Repertoires"))
  const blackHeading = ref(t("Black Repertoires"))
  const unknownHeading = ref(t("Unknown Color - Need to be Assigned"))
  const dataEntryInfoTitle = ref("")


  const managerTourInfo = {
    id : "repertoire_manager",
    video : "https://www.chessvis.com/videos/repertoires_on_web.mp4",
    elements : [
      { id: "", title: "Repertoire Manager", text : "Add, modify, delete repertoires here.<br><br>Repertoires must be associated with one color.<br><br>The video is for the entire set of repertoire routines."},
      { id: "the_toolbar", title: "Add - Toolbar", text : "Add an empty repertoire"},
      { id: "the_toolbar", title: "Copy - Toolbar", text : "Copy an existing repertoire to a new name"},
      { id: "the_toolbar", title: "Rename - Toolbar", text : "Rename a repertoire"},
      { id: "the_toolbar", title: "Set Color - Toolbar", text : "Repertoires must be assigned to a color.<br><br>Frequently when importing repertoires, Chessvis can't determine the color and will instead be put at the bottom in the 'Unknown Color' group."},
      { id: "the_toolbar", title: "Tree - Toolbar", text : "Display the tree for the selected repertoire"},
      { id: "the_toolbar", title: "Delete - Toolbar", text : "Delete one repertoire or switch to the <i>Multi-Selector</i> to delete any number.<br><br>This action requires verification."},
    ]
  }

  const exportTourInfo = {
    id : "repertoire_export",
    video : "https://www.chessvis.com/videos/repertoires_on_web.mp4",
    elements : [
      { id: "", title: "Repertoire Export", text : "Download any number of repertoires in a PGN for use in other programs.<br><br>The video is for the entire set of repertoire routines."}
    ]
  }

  // tour stuff
  const tourInfo = ref( (props.whoCalled == "export") ? exportTourInfo : managerTourInfo )

  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })

   updateWidthHeights()

   function updateWidthHeights() {
  
    const availableSpace = availableWidthHeight()
    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
  }
  // import sends a particular ID #

  getRepertoireManager( props.downloadID != "0" ? "2" : "1",props.downloadID)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  // delete yes/no

  function setupAlert(header,message,type,task) {
    alertInfo.value = { header : header, message : message, type : type, task : task  }
    alertTrigger.value++
  }

  function alertResult(response,task,info) {
    //console.log("Alert Result",response,task)

    if (response == "no")
      return

    switch (task) {
      case "color" :
        doDeleteOrColorChange("color",response)
        break
      case "delete" :
        //console.log("Yes delete")
        doDeleteOrColorChange("delete","")
        break
    }
  }

  // ADD Modal
  const addRepertoireModal = async () => {
    const modal = await modalController.create({
      component: ModalLegacyAddRepertoire,
      componentProps: {
        color : addColor,
        name : addName
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      makeChangeOnServer("add",data.name,data.color,"","0","0") 
    }
  };

  // Copy or Rename Modal
  const copyRenameRepertoireModal = async (action,id,name,color) => {
    const modal = await modalController.create({
      component: ModalLegacyCopyRepertoire,
      componentProps: {
        action : action,
        name : name,
        repertoireId : id
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //console.log("data",data,id,color)
      if (action == "copy")
        makeChangeOnServer(action,data.name,color,"",id,"0") 
      else
        makeChangeOnServer("change_name",data.name,"","","0",id) 
    }
  };

  function toolbarClick(index) {

    var questionString = ""
    var singlePlural = ""

    var element = findToolbarElement(toolbarElements.value,index)
    if (element != null && element.disabled)
      return

    //console.log("toolbar click")
    switch (index) {
      case TOOLBAR_DOWNLOAD :
        //console.log("DOWNLOAD")
        buildArrayOfSelectionEntries()
        if (selectedEntries.value.length == 0)
          return
        //console.log(selectedEntries.value)
        getDownload()
        break
      case TOOLBAR_DONE_FOR_IMPORT :
        emit("repertoire-manager-done")
        break;
      case TOOLBAR_COLOR :
        buildArrayOfSelectionEntries()
        if (selectedEntries.value.length == 0)
          return
        singlePlural = (selectedEntries.value.length == 1) ? t("Repertoire") : t("Repertoires")
        questionString = t("Select color to assign to") + " " + selectedEntries.value.length + " " 
                        + singlePlural
        setupAlert(t("Assign Repertoire Color"),questionString,"whiteblack","color")
        break
      case TOOLBAR_ADD :
        addRepertoireModal()
        break;
      case TOOLBAR_COPY :
        entryToCopy.value = findSingleSelectionEntry()
        if (entryToCopy.value == null)
          break
        copyRenameRepertoireModal("copy",entryToCopy.value.radio,entryToCopy.value.name,
                          entryToCopy.value.color)
        break
      case TOOLBAR_RENAME :
        entryToRename.value = findSingleSelectionEntry()
        if (entryToRename.value == null)
          return
        copyRenameRepertoireModal("rename",entryToRename.value.radio,entryToRename.value.name,
                    entryToRename.value.color)
        break;
      case TOOLBAR_DELETE :
        buildArrayOfSelectionEntries()
        if (selectedEntries.value.length == 0)
          return
        singlePlural = (selectedEntries.value.length == 1) ? t("Repertoire") : t("Repertoires")
        questionString = t("Do you want to delete") + " " + selectedEntries.value.length + " " 
                        + singlePlural + "?"
        setupAlert("Repertoire Deletion",questionString,"yesno","delete")
        break;
    }
  }

  function doAdd(flag) {
    //console.log("ADD",flag)
    if (newRepertoireName.value == "") {
      dataEntryInfoTitle.value = t("Name is empty")
      return
    }
    makeChangeOnServer("add",newRepertoireName.value,addColor,"","0","0") 
  }

  function doCopy(flag) {
    //console.log("COPY",flag)
    if (flag == false) {
      return
    }
    if (newRepertoireName.value == "") {
      dataEntryInfoTitle.value = t("Name is empty")
      return
    }
    makeChangeOnServer("copy",newRepertoireName.value,"","",entryToCopy.value.id,"0") 
  }

  function doRename(flag) {
    //console.log("RENAME",flag)
    if (flag == false) {
      return
    }
    if (newRepertoireName.value == "") {
      dataEntryInfoTitle.value = t("Name is empty")
      return
    }
    makeChangeOnServer("change_name",newRepertoireName.value,"","","0",entryToRename.value.id) 
  }

  function doDeleteOrColorChange(action,color) {
    var idArray = []
    //console.log("CONFIRM",action,color)

    for (var i=0; i < selectedEntries.value.length; i++)
      idArray.push(selectedEntries.value[i].id)
    const idString = idArray.join(",")
  
    makeChangeOnServer(action,"",color,idString,"0","0") 
  }

  function switchButtonClick() {
    showCheckbox.value = !showCheckbox.value
    buttonText.value = (showCheckbox.value) ? BUTTON_SWITCH_SINGLE : BUTTON_SWITCH_MULTIPLE
    allSelected.value = false
    setToolbarFlags()
  }

  // one repertoire is selected, find the entry for it
  function findSingleSelectionEntry() {
    var i = 0
    if (showCheckbox.value == false) {
      for (i = 0; i < whiteRepertoires.value.length; i++)
        if (whiteRepertoires.value[i].radio == selectedId.value)
          return (whiteRepertoires.value[i])
      for (i = 0; i < blackRepertoires.value.length; i++)
        if (blackRepertoires.value[i].radio == selectedId.value)
          return (blackRepertoires.value[i])
      for (i = 0; i < unknownRepertoires.value.length; i++)
        if (unknownRepertoires.value[i].radio == selectedId.value)
          return (unknownRepertoires.value[i])

      // shouldn't happen but ...
      return (null)
    }
    for (i = 0; i < whiteRepertoires.value.length; i++)
      if (whiteRepertoires.value[i].selected)
        return (whiteRepertoires.value[i])
    for (i = 0; i < blackRepertoires.value.length; i++)
      if (blackRepertoires.value[i].selected)
        return (blackRepertoires.value[i])
    for (i = 0; i < unknownRepertoires.value.length; i++)
      if (unknownRepertoires.value[i].selected)
        return (unknownRepertoires.value[i])
    return (null)
  }

  // build array of repertoires to either delete or set color
  function buildArrayOfSelectionEntries() {
    selectedEntries.value = []
    var i = 0
    if (showCheckbox.value == false) {
      for (i = 0; i < whiteRepertoires.value.length; i++)
        if (whiteRepertoires.value[i].radio == selectedId.value)
          selectedEntries.value.push(whiteRepertoires.value[i])
      for (i = 0; i < blackRepertoires.value.length; i++)
        if (blackRepertoires.value[i].radio == selectedId.value)
          selectedEntries.value.push(blackRepertoires.value[i])
      for (i = 0; i < unknownRepertoires.value.length; i++)
        if (unknownRepertoires.value[i].radio == selectedId.value)
          selectedEntries.value.push(unknownRepertoires.value[i])
      return
    }
    for (i = 0; i < whiteRepertoires.value.length; i++)
      if (whiteRepertoires.value[i].selected)
        selectedEntries.value.push(whiteRepertoires.value[i])
    for (i = 0; i < blackRepertoires.value.length; i++)
      if (blackRepertoires.value[i].selected)
        selectedEntries.value.push(blackRepertoires.value[i])
    for (i = 0; i < unknownRepertoires.value.length; i++)
      if (unknownRepertoires.value[i].selected)
        selectedEntries.value.push(unknownRepertoires.value[i])
  }

  function countSelected() {
    var count = 0

    if (showCheckbox.value == false) {
      if (selectedId.value != "")
        return 1
      return (0)
    }

    var i = 0
    for (i = 0; i < whiteRepertoires.value.length; i++)
      if (whiteRepertoires.value[i].selected)
        count++
    for (i = 0; i < blackRepertoires.value.length; i++)
      if (blackRepertoires.value[i].selected)
        count++
    for (i = 0; i < unknownRepertoires.value.length; i++)
      if (unknownRepertoires.value[i].selected)
        count++
    return (count)
  }

  function setToolbarFlags() {
    const checkCount = countSelected()

    //console.log("************ check count  ",checkCount)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COPY, checkCount != 1)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_RENAME, checkCount != 1)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_DELETE, checkCount == 0)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_COLOR, checkCount == 0)
    toolbarTrigger.value++
  }
  
  function onAllCheckboxClick() {
    var i = 0
    for (i = 0; i < whiteRepertoires.value.length; i++)
      whiteRepertoires.value[i].selected = allSelected.value
    for (i = 0; i < blackRepertoires.value.length; i++)
      blackRepertoires.value[i].selected = allSelected.value
    for (i = 0; i < unknownRepertoires.value.length; i++)
      unknownRepertoires.value[i].selected = allSelected.value
    setToolbarFlags()
  }

  function onCheckboxClick(event,color,index) {
    hasChanges.value = true
    //console.log("selected click",color,index)
    switch (color) {
      case "unknown" :
        //console.log("unknown", index, unknownRepertoires.value[index].selected)  
        break;
      case "white" :
        //console.log("white", index, whiteRepertoires.value[index].selected)
        break;
      case "black" :
        //console.log("black", index, blackRepertoires.value[index].selected)
        break;
    }
    setToolbarFlags()
  }

  function onRadioClick(event,color,index) {
    hasChanges.value = true
    //console.log("click",color,index,selectedId.value,selectedId.value)
    setToolbarFlags()
  }

  function tourDone() {
    showTour.value = false
  }

  function processJsonResponse(json) {
    //console.log("repertoire manager json",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    //console.log("*** process Game Collection ***")

    selectedId.value = "" + json['selected_id']

    whiteRepertoires.value = []
    blackRepertoires.value = []
    unknownRepertoires.value = []

    const whiteCount = json['white_count']
    const whiteId = json['white_id'].split("\t")
    const whiteName = json['white_name'].split("\t")
    const whitePractice = json['white_practice'].split("\t")

    for (var i = 0; i < whiteCount; i++)
      whiteRepertoires.value.push({ 
              color : "white",
              index : i,
              id : whiteId[i],
              name : whiteName[i],
              selected : false,
              radio : "" + whiteId[i]
            })

    const blackCount = json['black_count']
    const blackId = json['black_id'].split("\t")
    const blackName = json['black_name'].split("\t")
    const blackPractice = json['black_practice'].split("\t")

    for (var i = 0; i < blackCount; i++)
      blackRepertoires.value.push({ 
              color : "black",
              index : i,
              id : blackId[i],
              name : blackName[i],
              selected : false,
              radio : "" + blackId[i]
            })
      //console.log("black   ",blackRepertoires.value)

    const unknownCount = json['unknown_count']
    const unknownId = json['unknown_id'].split("\t")
    const unknownName = json['unknown_name'].split("\t")

    for (var i = 0; i < unknownCount; i++)
      unknownRepertoires.value.push({ 
              color : "unknown",
              index : i,
              id : unknownId[i],
              name : unknownName[i],
              selected : false,
              radio : "" + unknownId[i]

      })
      //console.log("unknown   ",unknownRepertoires.value)
      setToolbarFlags()
  }

  function getRepertoireManager(action,download_id) {
    var formData = {
      action : action,
      download : download_id
    }
    //console.log("before get repertoire manager ",formData)
    useGetData("chessvis_legacy_repertoire_manager.php", formData, processJsonResponse)
  }

  function processSetRepertoireJsonResponse(json) {
    //console.log("set repertoire json",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    const code = json['code']
    if (code == "good") {
      getRepertoireManager( props.downloadID != "0" ? "2" : "1",props.downloadID)
    }
    else 
      if (code == "name_in_use")
        dataEntryInfoTitle.value = "Name already in use"

  }

  function makeChangeOnServer(action,name,color,repertoireids,copyid,changeid) {

    var formData = {
      action : action,
      name : name,
      color : color,
      repertoireids : repertoireids,
      copyid : copyid,
      changeid : changeid
    }
    //console.log("before set rep ",formData)
    useGetData("chessvis_legacy_set_repertoire_info.php", formData, processSetRepertoireJsonResponse)
  }


watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
  })

  function getDownload() {
    const timeNow = Math.floor(Date.now() / 1000)

    var idArray = []
    for (var i=0; i < selectedEntries.value.length; i++)
        idArray.push(selectedEntries.value[i].id)
      const idString = idArray.join(",")

    const formData = {
      time : timeNow,
      ids : idString
    }

    useGetDataDownload("chessvis_legacy_get_repertoire_pgn.php", formData)
  }

</script>
  
<style scoped>

/*
https://stackoverflow.com/questions/10980822/scrollbar-without-fixed-height-dynamic-height-with-scrollbar
*/

/*
    https://getbootstrap.com/docs/5.0/forms/checks-radios/
*/

#repmanager-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin : 30px auto;
  padding : 15px 15px;
  line-height: 1.4em;
  width : 600px;
  height: calc(100vh - 125px);
  overflow-y: auto;
}

/* from bootstrap */

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: 0.125rem;
    line-height: 1.4em;
}

.form-check-input[type=checkbox] {
    border-radius: 0.25em;
}

.form-check-input:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
}

.form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: .5;
}

.form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
}

.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    border: 1px solid rgba(0,0,0,.25);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

.repmanager-center-text {
  text-align: center;
  margin-bottom : 10px;
  font-style :italic;
}

.repmanager-heading-color {
  background: #4c6ca0;
  color : white;
  text-align : center;
}

/* from bootstrap */

.form-check-input:checked[type=radio] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-label {
margin-left : 20px;
}
.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: .25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0,0,0,.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.btn-center {
  margin-left : 30px;
  margin-bottom : 10px;
}

#reptree-container {
  position : relative;
}

</style>